(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bf-cart-addons"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('change', function (event) {
    var select = event.target;
    if (!select || !select.matches || !select.matches('[data-bf-addon-select]')) return;
    var card = select.closest('.bf-addon');
    var price = card && card.querySelector('[data-bf-addon-price]');
    var option = select.options[select.selectedIndex];
    if (price && option && option.dataset.bfSalePrice) {
      price.innerHTML = '<span class="bf-sale bf-sale--card" data-bf-sale><span class="bf-sale__now"><span class="bf-sale__sr">Sale price </span>' + option.dataset.bfSalePrice + '</span> <span class="bf-sale__badge">Black Friday · 20% off</span></span>';
    } else if (price && option && option.dataset.price) price.textContent = option.dataset.price;
  });
  (function () {
    var timer = 0;
    function refresh() {
      var wrap = document.querySelector('.shopify-section[id$="__bf_cart_addons"], #shopify-section-bf_cart_addons');
      if (!wrap) return;
      var sectionId = wrap.id.replace(/^shopify-section-/, '');
      fetch(window.location.pathname + '?sections=' + encodeURIComponent(sectionId))
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (data) {
          if (!data || typeof data[sectionId] !== 'string') return;
          var box = document.createElement('div');
          box.innerHTML = data[sectionId];
          var fresh = box.querySelector('#' + CSS.escape(wrap.id)) || box;
          wrap.innerHTML = fresh.innerHTML;
        })
        .catch(function () {});
    }
    ['cart:update', 'cart:updated', 'cart:change'].forEach(function (name) {
      document.addEventListener(name, function () { window.clearTimeout(timer); timer = window.setTimeout(refresh, 400); });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
